export const properties = [
  {
    id: '4',
    title: 'Bali',
    type: 'Residential',
    location: 'Indonesia',
    size: 2110,
    monthlyYield: 12.88,
    imageUrl: 'https://rentfi.b-cdn.net/rentfi-bali-1.webp',
  },
  {
    id: '3',
    title: 'Medellín',
    type: 'Residential',
    location: 'Colombia',
    size: 1849,
    monthlyYield: 10.41,
    imageUrl: 'https://rentfi.b-cdn.net/rentfi-medellin-2.webp',
  },
  {
    id: '2',
    title: 'Vancouver',
    type: 'Residential',
    location: 'Canada',
    size: 1345,
    monthlyYield: 11.00,
    imageUrl: 'https://rentfi.b-cdn.net/rentfi-vancouver-1.webp',
  },
  {
    id: '1',
    title: 'Medellín',
    type: 'Residential',
    location: 'Colombia',
    size: 2877,
    monthlyYield: 12.34,
    imageUrl: 'https://rentfi.b-cdn.net/rentfi-medellin-1.webp',
  }
] as const;